// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import your translation files (you'll create these next)
import enTranslations from './locales/en/translation.json';
import heTranslations from './locales/he/translation.json';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languagedetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en', // default language if detected language is not available
    debug: true, // Set to false in production

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    resources: {
      en: {
        translation: enTranslations,
      },
      he: {
        translation: heTranslations,
      },
    },

    // Options for LanguageDetector
    detection: {
      order: ['localStorage', 'navigator'], // Try to detect from local storage first, then browser
      caches: ['localStorage'], // Cache user language in local storage
    }
  });

export default i18n;